package de.jensklingenberg.showdown

const val debugPort = 23567
